// extracted by mini-css-extract-plugin
module.exports = {"movies":"styles_movies__2iPCe","imageContainer":"styles_imageContainer__38q1i","fadeIn":"styles_fadeIn__3OOMV","movieTitle":"styles_movieTitle__1X8P9"};